window.ADDRESSREVERSEAPI = "https://api-adresse.data.gouv.fr/reverse/";

window.env_moder = [2441, 2438, 3420, 3686, 3691];
window.env_assign = [2430, 3418, 3685, 3690];
window.coords = [43.3874058, -1.6643563];


switch (window.location.hostname) {
    case 'odp-gestion.clicmap.fr':
        window.urlapi = "https://odp-gestion.clicmap.fr/devInc/";
        document.documentElement.style.setProperty("--primary", "#0e2ed0");
        document.documentElement.style.setProperty("--primary-fonce", "#0A1E9D");
        break;
    case 'odp-moder.clicmap.fr':
        window.urlapi = "https://odp-moder.clicmap.fr/inc/";
        document.documentElement.style.setProperty("--primary", "#D00E1C");
        document.documentElement.style.setProperty("--primary-fonce", "#9D0A0A");
        break;
    default:
        window.urlapi = "https://odp-gestion.clicmap.fr/devInc/";
        document.documentElement.style.setProperty("--primary", "#d00e1c");
        document.documentElement.style.setProperty("--primary-fonce", "#9D0A0A");
        break;
}

window.url_ws = window.urlapi;